import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { Component } from 'react';
import { withAnalyticsEvents, withAnalyticsContext, createAndFireEvent } from '@atlaskit/analytics-next';
import Button from '@atlaskit/button';

import { name as packageName, version as packageVersion } from '../../package.json';

import { defaultI18n } from '../internal/props';
import { Container, Ellipsis, ButtonActive } from '../styled';
import pageRange from '../internal/page-range';

var MAX_VISIBLE_PAGES = 7;

var Pagination = function (_Component) {
  _inherits(Pagination, _Component);

  function Pagination() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Pagination);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || _Object$getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      current: _this.props.defaultValue
    }, _this.onPageChange = function (page) {
      if (_this.props.value) {
        _this.props.onChange(page);
      } else {
        _this.setState({ current: page });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Pagination, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.defaultValue !== nextProps.defaultValue) {
        this.setState({ current: nextProps.defaultValue });
      }
    }
  }, {
    key: 'getCurrentPage',
    value: function getCurrentPage() {
      return this.props.value ? this.props.value : this.state.current;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          total = _props.total,
          i18n = _props.i18n;

      if (!i18n || !i18n.prev || !i18n.next) {
        throw new Error('Pagination component provided unusable i18nShape');
      }
      var current = this.getCurrentPage();

      return total === 0 ? null : React.createElement(
        Container,
        null,
        React.createElement(
          Button,
          {
            appearance: 'link',
            isDisabled: current === 1,
            onClick: function onClick() {
              return _this2.onPageChange(current - 1);
            }
          },
          i18n.prev
        ),
        pageRange(MAX_VISIBLE_PAGES, current, total).map(function (pageNum, i) {
          var isDisabled = pageNum === current;
          var Element = isDisabled ? ButtonActive : Button;
          var key = pageNum + '-' + i;
          return pageNum === '...' ? React.createElement(
            Ellipsis,
            { key: key },
            '...'
          ) : React.createElement(
            Element,
            {
              isDisabled: isDisabled,
              key: key,
              appearance: 'link'
              // $FlowFixMe fails to narrow type after ternary
              , onClick: function onClick() {
                return _this2.onPageChange(pageNum);
              }
            },
            pageNum
          );
        }),
        React.createElement(
          Button,
          {
            appearance: 'link',
            isDisabled: current === total,
            onClick: function onClick() {
              return _this2.onPageChange(current + 1);
            }
          },
          i18n.next
        )
      );
    }
  }]);

  return Pagination;
}(Component);

Pagination.defaultProps = {
  defaultValue: 1,
  i18n: defaultI18n,
  onChange: function onChange() {},
  total: 0
};


export { Pagination as PaginationWithoutAnalytics };
var createAndFireEventOnAtlaskit = createAndFireEvent('atlaskit');

export default withAnalyticsContext({
  componentName: 'pagination',
  packageName: packageName,
  packageVersion: packageVersion
})(withAnalyticsEvents({
  onChange: createAndFireEventOnAtlaskit({
    action: 'changed',
    actionSubject: 'pageNumber',

    attributes: {
      componentName: 'pagination',
      packageName: packageName,
      packageVersion: packageVersion
    }
  })
})(Pagination));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/pagination/dist/esm/components/Pagination.js
// module id = 842
// module chunks = 0